export default {
  meta: {
    title: '筹建任务管理',
  },
};
